import { render, staticRenderFns } from "./SingleItem.vue?vue&type=template&id=bb8929ea&"
import script from "./SingleItem.vue?vue&type=script&lang=js&"
export * from "./SingleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/51881/189/Woerner/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb8929ea')) {
      api.createRecord('bb8929ea', component.options)
    } else {
      api.reload('bb8929ea', component.options)
    }
    module.hot.accept("./SingleItem.vue?vue&type=template&id=bb8929ea&", function () {
      api.rerender('bb8929ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/woerner/SingleItem.vue"
export default component.exports